import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/provisioningActions';
const apiUrls = require('constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  getProvisioningStatus: (serviceNo, store) => {

    const billingSystem = 'Icoms';

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const url = apiUrls.PROVISIONING_STATUS_URL;

    return ajax({
      url: `${url}?billingSystem=${billingSystem}&serviceno=${serviceNo}`,
      method: 'get',
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  }
};

export const getProvisioningStatusEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.PROVISIONING_STATUS_REQUEST_STARTED)
  .mergeMap(action => call(api.getProvisioningStatus, action.serviceNo, store).map(payload => {
    return (actions.getProvisioningStatusFinished(payload.response, action.serviceNo, action.accountNumber));
  })
    .catch(error => of(actions.getProvisioningStatusFailed(error, action.serviceNo, action.accountNumber))));



// WEBPACK FOOTER //
// ./src/epics/provisioningEpics.js